import React from 'react';
import { motion } from 'framer-motion';
import pc1 from '../../assets/image/service/pc1.png';
import pc2 from '../../assets/image/service/pc2.png';
import pc3 from '../../assets/image/service/pc3.png';

const Service = () => {
    const services = [
        { icon: pc2, title: "Desarrollo Web", desc: "Desarrollo Web profesional para hacer realidad tu visión online." },
        { icon: pc1, title: "Software a medida", desc: "Transformando ideas complejas en software personalizado y eficiente." },
        { icon: pc3, title: "Productos", desc: "Elige uno de nuestros productos ya construidos para tus requerimientos." },
    ];

    return (
        <section id="services" className="py-24 relative bg-dark-900/50">
            <div className="container mx-auto px-4 lg:px-8">
                {/* Header */}
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    className="text-center mb-16"
                >
                    <span className="text-accent-cyan font-medium tracking-widest text-sm uppercase mb-3 block">
                        Qué Hago
                    </span>
                    <h2 className="text-4xl md:text-5xl font-bold font-display text-white mb-6">
                        Mis Servicios
                    </h2>
                    <div className="w-24 h-1 bg-gradient-to-r from-accent-blue via-accent-cyan to-accent-purple mx-auto rounded-full"></div>
                </motion.div>

                {/* Grid */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {services.map((service, index) => (
                        <motion.div 
                            key={index}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-50px" }}
                            transition={{ duration: 0.5, delay: index * 0.15 }}
                            className="glass-card p-8 rounded-2xl group hover:-translate-y-2 transition-all duration-300 hover:shadow-[0_15px_30px_rgba(34,211,238,0.1)] text-center relative overflow-hidden flex flex-col items-center justify-start h-full"
                        >
                            <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                            
                            <div className="w-20 h-20 mb-6 p-4 rounded-2xl bg-dark-800 border border-white/10 group-hover:border-accent-cyan/30 transition-colors duration-300 transform group-hover:scale-110 flex items-center justify-center">
                                <img src={service.icon} alt={service.title} className="max-w-full max-h-full object-contain" />
                            </div>
                            
                            <h3 className="text-xl font-bold text-white mb-4 group-hover:text-accent-cyan transition-colors z-10">{service.title}</h3>
                            <p className="text-slate-400 leading-relaxed font-light z-10">{service.desc}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
            {/* Background elements */}
            <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10">
                <div className="absolute top-1/3 left-1/4 w-96 h-96 bg-accent-blue/5 rounded-full blur-[100px]"></div>
            </div>
        </section>
    );
};

export default Service;